module.exports = __webpack_public_path__ + "img/GAME_POND1.db0c0ddd.jpg";